interface Props {
  portions: number;
  onUse: () => void;
  onAdjust?: (delta: number) => void;
  disabled?: boolean;
  unitLabel?: string;
}

export function PortionCounter({ portions, onUse, onAdjust, disabled, unitLabel = "Use one" }: Props) {
  const low = portions <= 2;
  return (
    <div className="flex items-center gap-3">
      {onAdjust ? (
        <button className="w-7 h-7 border border-paper-300 hover:border-ink text-ink"
          onClick={() => onAdjust(-1)} disabled={disabled || portions === 0}>−</button>
      ) : null}
      <span className={`tabular-nums font-display text-3xl ${low ? "text-red-700" : "text-ink"}`}>
        {portions}
      </span>
      {onAdjust ? (
        <button className="w-7 h-7 border border-paper-300 hover:border-ink text-ink"
          onClick={() => onAdjust(1)} disabled={disabled}>+</button>
      ) : null}
      <button className="btn-primary ml-2" onClick={onUse} disabled={disabled || portions === 0}>
        {unitLabel}
      </button>
    </div>
  );
}
